import {lazy} from 'react';

const ReportGroup = lazy(() => import('containers/report/reportGroup/ReportGroup'));
const Report = lazy(() => import('containers/report/report/Report'));
const Connection = lazy(() => import('containers/report/connection/Connection'));
const APIConfig = lazy(() => import('containers/report/apiConfig/APIConfig'));
const ReportDynamic = lazy(() => import('containers/report/reportDynamic/ReportDynamic'));
const ExportHistory = lazy(() => import('containers/report/exportHistory/ExportHistory'));
const routes = [
    {path: '/', exact: true, name: 'Home'},
    {path: '/category', exact: true, name: 'Category'},
    {path: '/category/reportGroup', name: 'ReportGroup', exact: true, component: ReportGroup},
    {path: '/category/report', name: 'Report', exact: true, component: Report},
    {path: '/category/connection', name: 'Connection', exact: true, component: Connection},
    {path: '/category/apiConfig', name: 'APIConfig', exact: true, component: APIConfig},
    {path: '/report/reportDynamic/:reportCode', name: 'ReportDynamic', exact: true, component: ReportDynamic},
    {path: '/exportHistory', name: 'ExportHistory', exact: true, component: ExportHistory},
];

export default routes;
